/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'button/check': {
    width: 16,
    height: 15,
    viewBox: '0 0 16 15',
    data: '<path pid="0" d="M2.125 7.826L6.606 12l6.519-8" _stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
  }
})
